import { EXO_SKELETON_EVENT_NAMES } from './consts';
import { createPostMessageEventHandler, hasExoSkeletonListenerInitialized, sendRuntimeDataEvent } from './runtime';
export const NAVIGATION_HOST_MESSAGE_EVENT_NAME = EXO_SKELETON_EVENT_NAMES.NAVIGATION_HOST_MESSAGE_EVENT_NAME;
function isNavigationDataEvent(data) {
  return (data === null || data === void 0 ? void 0 : data.type) === NAVIGATION_HOST_MESSAGE_EVENT_NAME;
}

/**
 * Used to create a host for the ExoSkeleton navigation.
 */
export function createNavigationListener(_ref) {
  let {
    onNavigate
  } = _ref;
  return createPostMessageEventHandler(NAVIGATION_HOST_MESSAGE_EVENT_NAME, function (_ref2) {
    let {
      data
    } = _ref2;
    if (isNavigationDataEvent(data)) {
      onNavigate(data);
    }
  });
}
export function navigate(to) {
  if (!hasExoSkeletonListenerInitialized(NAVIGATION_HOST_MESSAGE_EVENT_NAME)) {
    console.warn('"navigate" was called, but the ExoSkeleton host did not initialize the "createNavigationListener". Data sent:', {
      to
    });
  }
  return sendRuntimeDataEvent(NAVIGATION_HOST_MESSAGE_EVENT_NAME, {
    to
  });
}
//# sourceMappingURL=navigation.js.map